module.exports = __webpack_public_path__ + "assets/c38da27536f1ba9987a8a6116fb1a787.png";